import { AideAgricoleStubPage } from '../../../../components/aides/AideAgricoleStubPage';
import { getAideAgricoleStub } from '../../../../config/aides-agriculteurs';

export default function OptimisationTurpePage() {
  const aide = getAideAgricoleStub('optimisation-turpe');
  if (!aide) return null;
  return <AideAgricoleStubPage aide={aide} />;
}
